import { RefObject, useEffect, useState } from "react";
import stringWidth from "string-width";

export const useTitleFontSize = (
  targetRef: RefObject<HTMLDivElement>,
  text?: string
) => {
  const [width, setWidth] = useState(0);
  const [fontSize, setFontSize] = useState("auto");

  useEffect(() => {
    if (text === undefined) return;

    const maxLengthText = Math.max(
      ...text.split(/\r\n|\n|<br \/>|<br>/).map((t) => stringWidth(t))
    );

    let sizePx = (width / maxLengthText) * 1.6;
    if (window.innerWidth > 1080) {
      // PCサイズ
      sizePx = Math.min(sizePx, 20);
    } else {
      // SPサイズ
      sizePx = Math.max(sizePx, 6.2);
    }

    setFontSize(`${sizePx}px`);
  }, [width, text]);

  useEffect(() => {
    if (targetRef.current === null) return;

    setWidth(targetRef.current.getBoundingClientRect().width);
    const ro = new ResizeObserver((e) => {
      setWidth(e[0].contentRect.width);
    });
    ro.observe(targetRef.current);
    return () => ro.disconnect();
  }, [targetRef]);

  return fontSize;
};
